import { useState } from "react";
import ControlsDrawerButton from "../../components/ui/ControlsDrawerButton";
import ControlsDrawer from "../../components/ui/ControlsDrawer";

export default function DrawerSection({ hidden }: { hidden?: boolean }) {
  const [open, setOpen] = useState(() => window.innerWidth >= 768);

  if (hidden) return null;

  return (
    <>
      <ControlsDrawerButton onOpen={() => setOpen(true)} />
      <ControlsDrawer open={open} onClose={() => setOpen(false)} />
    </>
  );
}
